<template>
  <div class="cc">
    <div class="top">
      <div class="topitem" :class="[active===0?'bg-font_'+platformInfo.skin:'']" @click="active = 0">
        <div class="topsel" :style="{backgroundImage:'url('+bcUrl+')'}" v-show="active===0"></div>
        <img v-show="active === 0" :src="require('@/assets/skins/'+platformInfo.skin+'/edit_color_highlight@3x.png')" class="topimg" />
        <img v-show="active !== 0"  src="./zheng/edit_color_nomal@3x.png" class="topimg" />
        背景
      </div>
      <div class="topitem" :class="[active===1?'bg-font_'+platformInfo.skin:'']" @click="active = 1">
        <div class="topsel" :style="{backgroundImage:'url('+bcUrl+')'}" v-show="active===1"></div>
        <img v-show="active === 1" :src="require('@/assets/skins/'+platformInfo.skin+'/edit_clothes_highlight@3x.png')" class="topimg" />
        <img v-show="active !== 1" src="./zheng/edit_clothes_nomal@3x.png" class="topimg" />
        换装
      </div>
      <div class="topitem" :class="[active===2?'bg-font_'+platformInfo.skin:'']" @click="active = 2">
        <div class="topsel" :style="{backgroundImage:'url('+bcUrl+')'}" v-show="active===2"></div>
        <img v-show="active === 2" :src="require('@/assets/skins/'+platformInfo.skin+'/edit_face_highlight@3x.png')" class="topimg" />
        <img v-show="active !== 2" src="./zheng/edit_face_nomal@3x.png" class="topimg" />
        美颜
      </div>
    </div>
    <div class="middle beijing" v-show="active === 0">
      <div v-for="(item,index) in colors"
           :key="item.color_name"
           class="ball"
           :style="{background:'linear-gradient(#'+item.s_color+',#'+item.e_color+')',
           background:'-webkit-linear-gradient(#'+item.s_color+',#'+item.e_color+')',
           border:item.s_color==='ffffff' && item.e_color === 'ffffff'?'2px solid hsla(0, 0%, 73%, 0.3)':item.s_color!==item.e_color?'2px solid #'+item.e_color:'2px solid hsla(0, 0%, 100%, 0.3)'}"
           @click="selball(index)"
      >
        <img v-show="bgColor===index" src="./zheng/color_selected.png" class="acball" />
      </div>
    </div>
    <div class="middle hz" v-show="active === 1">
      <div class="closewrap">
        <img v-show="closeKey!==''" src="./zheng/edit_clothes_no_nomal@3x.png" class="xuan" @click="closeFn('')"/>
        <img v-show="closeKey===''" :src="require('@/assets/skins/'+platformInfo.skin+'/edit_clothes_no_highlight@3x.png')" class="xuan" />
        <div v-show="item.type===selType"
             v-for="item in closes"
             :key="item.key"
             class="xuan"
             :class="{selxuan:closeKey===item.key}"
             @click="closeFn(item.key)">
          <img :src="item.value" class="cloimg" />
        </div>
      </div>
      <div class="typewrap">
        <div class="t" :class="[selType === 'girl'?'bg-font_'+platformInfo.skin:'']" @click="selType = 'girl'">女装</div>
        <div class="t" :class="[selType === 'boy'?'bg-font_'+platformInfo.skin:'']" @click="selType = 'boy'">男装</div>
        <div class="t" :class="[selType === 'kid'?'bg-font_'+platformInfo.skin:'']" @click="selType = 'kid'">童装</div>
      </div>
    </div>
    <div class="middle my" v-show="active === 2">
      <div class="meiyan" :class="[!beautyFlag?'bg-font_'+platformInfo.skin:'']" @click="setbeauty(false)">
        <img v-show="beautyFlag" src="./zheng/edit_face_nomal@3x(1).png" class="mimg"/>
        <img v-show="!beautyFlag" :src="require('@/assets/skins/'+platformInfo.skin+'/edit_face_no_highlight@3x.png')" class="mimg"/>
        无美颜
      </div>
      <div class="meiyan" :class="[beautyFlag?'bg-font_'+platformInfo.skin:'']" @click="setbeauty(true)">
        <img v-show="!beautyFlag" src="./zheng/edit_face_yes_nomal@3x.png" class="mimg"/>
        <img v-show="beautyFlag" :src="require('@/assets/skins/'+platformInfo.skin+'/edit_face_yes_highlight@3x.png')" class="mimg"/>
        智能美颜
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions,mapState } from 'vuex';
export default {
  props: {
    colors: {
      type: Array,
      default: [],
    },
    bgColor: {
      type: Number,
      default: 0
    },
    closeKey: {
      type: String,
      default: ''
    },
    beautyFlag: {
      type: Boolean,
      defaultL: true
    }
  },
  data() {
    return{
       active: 0,
       typearr: [],
       closes: [],
       selType: 'girl',
       bcUrl:''
    }
  },
  activated() {
    if(!this.actiBol){
      return;
    }
    this.closeList().then(res => {
      let data = res.data;
      this.typearr = Object.keys(data);
      let arr = []
      this.typearr.forEach(element => {
        let darr = data[element].map(item => {
          return {
            ...item,
            type: element
          }
        });
        arr = [...arr,...darr];
      });
      this.closes = arr;
    })
    this.bcUrl = require('@/assets/skins/'+this.platformInfo.skin+'/edit_bar_selected@3x.png')
    this.active = 0
    this.selType = 'girl'
  },
  computed:{
			...mapState(['platformInfo', 'actiBol'])
		},
  methods: {
    ...mapActions(['closeList']),
    selball(idx) {
      if (this.bgColor === idx) {
        return;
      }
      this.$emit('selIndex',idx);
    },
    closeFn(key) {
      if (this.closeKey === key) {
        return;
      }
      this.$emit('selkey',key);
    },
    setbeauty(bol) {
      if (this.beautyFlag === bol) {
        return;
      }
      this.$emit('setbeauty',bol);
    }
  }
}
</script>

<style scoped>
.cc {
  background-color: white;
}
.top {
  display: flex;
  align-items: center;
  font-size: 0.14rem;
  color: #999999;
}
.topitem {
  flex-grow: 1;
  flex-shrink: 0;
  text-align: center;
  height: 0.56rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.topimg {
  width: 0.18rem;
  height: 0.18rem;
  margin-right: 0.06rem;
  position: relative;
}
.topsel {
  position:absolute;
  width:100%;
  height:100%;
  z-index: 0;
  background-image: url("./zheng/edit_bar_selected@3x.png");
  background-repeat: no-repeat;
  background-size: contain;
  /* color: #3E7DFF; */
}
.middle {
  height: 1.32rem;
}
.beijing {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.ball {
  width: 0.5rem;
  height: 0.5rem;
  box-sizing: border-box;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.acball {
  width: 0.16rem;
}
.hz {
    box-sizing: border-box;
    padding: 0.12rem 0 0;
}
.closewrap {
    display: flex;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0 0.3rem
}
.xuan {
  width: 0.72rem;
  height: 0.6rem;
  display: block;
  margin-right: 0.1rem;
  flex-shrink: 0;
  position: relative;
}
.selxuan::before {
  display: block;
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0,0,0,0.4);
  background-image: url("./zheng/edit_clothes_selected@3x.png");
  background-repeat: no-repeat;
  background-size: 0.24rem;
  background-position: center;
}
.cloimg {
  width: 100%;
  height: 100%;
}
.typewrap {
  display: flex;
  margin-top: 0.12rem;
  box-sizing: border-box;
  padding: 0 1rem;
  justify-content: space-between;
  font-size: 0.14rem;
  color: #999999;
}
.activeColr {
  color: #3E7DFF!important;
}
.my {
  box-sizing: border-box;
  padding: 0 0.85rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.meiyan {
  text-align: center;
  font-size: 0.12rem;
  color: #999999;
}
.mimg {
  display: block;
  width: 0.5rem;
  height: 0.5rem;
  margin: 0 auto 0.1rem;
}
</style>


